import { PropsWithChildren } from "react";
import clsx from "clsx";

interface Props {
  className?: string;
}

export default function FieldCard(props: PropsWithChildren<Props>) {
  const { children, className } = props;

  return (
    <div
      className={clsx(
        "rounded-xl border border-border bg-white p-4 shadow-sm",
        className
      )}
    >
      {children}
    </div>
  );
}
